import { useState } from 'react'
import { useEffectOnce } from 'react-use'

import { FederationRoot, useFederationRoot } from '@constructor/federation/base'
import { createFederationRouterFabric } from '@constructor/federation/react'

import { createRequester } from '@constructor/services'
import { useAiChat } from '@/features/km/aiChat'
import { isNewLearnerMF } from '@/features/learnerMF/isNewLearnerMF'
import { appRouter } from '@/index'
import i18n from '@/plugins/i18n'

export const useInitMicroFrontends = () => {
  const [federationRoot, setFederationRoot] = useState<FederationRoot>()

  useEffectOnce(() => {
    const requester = createRequester()

    const federationRoot = useFederationRoot({
      processException: (error: any) => {
        console.error(error)
      },
      requester,
      i18next: i18n,
    })

    federationRoot.setRouterFabric(createFederationRouterFabric({ router: appRouter }))

    const fragmentNames = [
      'calendar-widget',
      'calendar-main',
      'knowledge-center',
      'communications-hub',
      'promo-banners-widget',
      'learner-dashboard',
      'tasks',
      'recent-courses',
    ]

    if (isNewLearnerMF()) {
      fragmentNames.push('learner-app')
    }

    federationRoot.loadVersions({ projectName: 'learn' }).then(() => {
      fragmentNames.forEach((fragmentName) => {
        if (federationRoot.hasVersion(fragmentName)) {
          federationRoot.preload({ fragmentName })
        } else {
          console.error(`Version for fragment: ${fragmentName} not found`)
        }
      })
    })

    const { getAiChatApi } = useAiChat(federationRoot)
    federationRoot.addRootHandler('getAiChatApi', getAiChatApi)
    setFederationRoot(federationRoot)
  })

  return { federationRoot }
}
